<template>
  <b-modal
      id="fba-barcode-modal"
      ref="fba-barcode-modal"
      hide-footer
      hide-header
      size="lg"
      @hidden="handHiden"
      @shown="handShown"
  >
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
    <div id="printArea">
        <div class="book" 
            v-if="$store.state.azFbaBasket.selectedBasketitems.includes(selectedBasketitem.id)" 
            v-for="(selectedBasketitem, index) in _baskets" 
            :key="selectedBasketitem.id"
        >
            <div class="page">
                <div class="subpage2">
                    <VueBarcode :value="selectedBasketitem.fn_sku"/>
                    <div class="fnSku">{{ selectedBasketitem.fn_sku }}</div>
                    <div class="productName">{{ selectedBasketitem.product.name }}</div>
                    <div class="productBarcode">{{ selectedBasketitem.product.barcode }}</div>
                    <div class="merchantSku">{{ selectedBasketitem.az_product.merchant_sku }}</div>
                </div>
            </div>
        </div>
    </div>
    <b-button class="pull-right" variant="success" @click="print">Yazdır</b-button>
  </b-modal>
    </template>

<script>
import { mapGetters } from 'vuex';
import VueBarcode from 'vue-barcode';
export default {
    name: 'FbaBarcode',
    components: {
        VueBarcode
    },
    computed: {
       ...mapGetters('azFbaBasket', ['_baskets', '_selectedBasketitems']),
    },
    methods: {
        handHiden() {
            this.$store.commit('azFbaBasket/setSelectedBasketitems', [])
        },
        async handShown() {
            await this.$htmlToPaper('printArea');
        },
        async print() {
        await this.$htmlToPaper('printArea');
        }
    }
}
</script>

<style scoped>
</style>